import React from 'react';
import styled from 'styled-components';
import { Border, Breakpoints, Color, Grid, Shadow, Type } from '../../app/StyleGuide';
import { Body, Content, Actions } from './Layout';
import { Poster } from './Poster';
import { Title } from './Title';
import { Metadata, Details } from './Metadata';
import { Progress } from './Progress';
import { Footer, UpNext } from './Footer';

// ---------------------------------------------------------------------------
// AssignmentCard (Root)
// ---------------------------------------------------------------------------

const StyledRoot = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: ${Shadow.small};
  border: 1px solid rgba(0, 0, 0, 0.075);
  border-radius: ${Border.radius};
  background: white;

  h4 {
    line-height: ${Type.Leading.normal};
    margin: 0 ${Grid._4} 0 0;
    font-weight: ${Type.Weight.bold};
    word-break: break-word;

    a {
      color: ${Color.Gray._90};
      display: block;
      &:hover {
        text-decoration: underline;
      }
    }

    @media screen and (min-width: ${Breakpoints.screen_sm}) {
      line-height: ${Type.Leading.tall};
    }
  }

  ul {
    list-style: none;
    padding: 0;
  }

  li {
    color: ${Color.Gray._70};
  }
`;

function AssignmentCard(props: React.HTMLAttributes<HTMLDivElement>) {
  return <StyledRoot {...props} />;
}

// ---------------------------------------------------------------------------
// Header
// ---------------------------------------------------------------------------

const StyledHeader = styled.div`
  padding: ${Grid._4};
  background: ${Color.Gray._01};
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  color: ${Color.Gray._70};
`;

type HeaderProps = {
  currentCourse: number;
  totalCourses: number;
  pathwayName: string;
};

function Header({ currentCourse, totalCourses, pathwayName }: HeaderProps) {
  return (
    <StyledHeader>
      <span>
        Course {currentCourse} of {totalCourses} in {pathwayName}
      </span>
    </StyledHeader>
  );
}

// ---------------------------------------------------------------------------
// Compound assembly
// ---------------------------------------------------------------------------

AssignmentCard.Header = Header;
AssignmentCard.Body = Body;
AssignmentCard.Poster = Poster;
AssignmentCard.Content = Content;
AssignmentCard.Actions = Actions;
AssignmentCard.Title = Title;
AssignmentCard.Metadata = Metadata;
AssignmentCard.Details = Details;
AssignmentCard.Progress = Progress;
AssignmentCard.Footer = Footer;
AssignmentCard.UpNext = UpNext;

export { AssignmentCard };
